import ContentHeader from "components/ContentHeader";

export default function InterviewForm() {
    return (
        <ContentHeader title={"Interview User"} />
    );
}